import payRequest from "./payRequest";
import returnPay from './returnPay'

export const payRequestPromise = payRequest;
export const returnPayPromise = returnPay;